import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { SMapService } from '@summit/maps';

const GOOGLE_MAPS_API_PATH = `https://maps.googleapis.com/maps/api/js?key=${environment['googleMapApiKey']}&libraries=drawing`;
@Injectable({
  providedIn: 'root'
})
export class MapService extends SMapService {
  //private isLoadedBs = new BehaviorSubject<boolean>(false);
  //isLoaded$: Observable<boolean>;
  private apiKey: string;
  private loadingInProgress = false;
  // Track script element for optional unload
  private scriptEl?: HTMLScriptElement;

  constructor(private httpClient: HttpClient) {
    super();
  }

  override loadApi(): Observable<boolean> {
    // Already loaded
    if (this.mapLoadedBs.value) return this.mapLoaded$;

    // If global already present (another part of app injected it) mark loaded
    if (typeof window !== 'undefined' && (window as any).google?.maps) {
      this.mapLoadedBs.next(true);
      return this.mapLoaded$;
    }

    // Idempotent: if a load is already in progress just return the observable
    if (this.loadingInProgress) return this.mapLoaded$;
    this.loadingInProgress = true;

    // Reuse existing script tag if found
    const existing = document.querySelector('script[data-google-maps-api]') as HTMLScriptElement | null;
    if (existing) {
      this.scriptEl = existing;
      // Attach onload if not yet finished
      if (!(window as any).google?.maps) {
        existing.addEventListener('load', () => this.mapLoadedBs.next(true), { once: true });
      } else {
        this.mapLoadedBs.next(true);
      }
      return this.mapLoaded$;
    }

    // Inject via JSONP (Angular HttpClient.jsonp handles callback wiring)
    this.httpClient.jsonp(GOOGLE_MAPS_API_PATH, 'callback').subscribe({
      next: () => {
        this.loadingInProgress = false;
        this.mapLoadedBs.next(true);
      },
      error: (err) => {
        this.loadingInProgress = false;
        console.error('[MapService] Google Maps API load failed', err);
      }
    });
    return this.mapLoaded$;
  }

  // Optional advanced: allow unloading for testing / memory release
  unloadApi(): void {
    if (this.scriptEl) {
      this.scriptEl.remove();
      this.scriptEl = undefined;
    } else {
      // Try to find by src pattern if we didn't cache earlier
      const candidate = Array.from(document.getElementsByTagName('script')).find((s) =>
        s.src?.startsWith('https://maps.googleapis.com/maps/api/js')
      );
      candidate?.remove();
    }
    // Delete global references (guarded)
    if (typeof window !== 'undefined' && (window as any).google) {
      try {
        delete (window as any).google.maps;
      } catch {
        // ignore if delete fails
      }
    }
    this.loadingInProgress = false;
    this.mapLoadedBs.next(false);
  }
}
